/**
 * Substituto do `withWidth` (removido em MUI v5).
 *
 * O codemod do MUI v5 substituiu o `withWidth` em ~94 arquivos do coruja
 * por um stub que SEMPRE retornava `'xs'`, fazendo o layout ficar como
 * mobile mesmo em desktop. Este shim usa `useMediaQuery` pra detectar
 * o breakpoint atual de verdade.
 *
 * Uso (mantém API antiga):
 *   import withWidth from '<caminho>/components/useWidth';
 *   export default withWidth()(MyComponent);
 *
 * @module components/useWidth
 */
import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function withWidth() {
  return function withWidthHOC(WrappedComponent) {
    return function WithWidthWrapper(props) {
      const theme = useTheme();
      // useMediaQuery não pode ser chamado condicionalmente — sempre 4.
      const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));
      const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
      const matchesMd = useMediaQuery(theme.breakpoints.up('md'));
      const matchesSm = useMediaQuery(theme.breakpoints.up('sm'));
      let width = 'xs';
      if (matchesXl) width = 'xl';
      else if (matchesLg) width = 'lg';
      else if (matchesMd) width = 'md';
      else if (matchesSm) width = 'sm';
      return <WrappedComponent {...props} width={width} />;
    };
  };
}

export default withWidth;
